var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddHeaderButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.13 6.332a.499.499 0 00.498-.498.493.493 0 00-.495-.495l-4.65.011L6.494.7A.493.493 0 006 .207a.5.5 0 00-.497.497l-.011 4.65-4.593.01a.5.5 0 00-.497.498c-.001.274.22.496.495.495l4.592-.01-.01 4.592c-.002.274.22.496.494.495a.5.5 0 00.497-.497l.012-4.593 4.65-.011z",
    fill: "#fff"
  })));
}
export default SvgAddHeaderButton;